import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@mui/material';

const SecondaryButton = ({ children, disabled, fullWidth, type, onClick }) => (
  <Button
    color="secondary"
    disabled={disabled}
    fullWidth={fullWidth}
    type={type}
    variant="contained"
    onClick={onClick}
  >
    {children}
  </Button>
);

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  // Sometimes we use form to handle submit, so no onClick callback is needed
  onClick: PropTypes.func,
};

SecondaryButton.defaultProps = {
  disabled: false,
  fullWidth: false,
  type: 'button',
};

export default SecondaryButton;
